import MerchantAccountListView from '@/views/MerchantAccounts/MerchantAccountListView/MerchantAccountListView.vue'
import MerchantAccountDetailView from '@/views/MerchantAccounts/MerchantAccountDetailView/MerchantAccountDetailView.vue'

export default [
  {
    path: '/merchants/:merchantID/merchant-accounts',
    component: MerchantAccountListView,
    name: 'MerchantAccountList'
  },
  {
    path: '/merchants/:merchantID/merchant-accounts/:merchantAccountID',
    component: MerchantAccountDetailView,
    name: 'MerchantAccountDetail'
  }
]
